import { EnvSchema } from '../entities/envSchema';

const zlb: EnvSchema = {
  env: 'zlb',
  envName: '浙里报',
};

export default zlb;
